// 设置委托字段
import dayjs from 'dayjs'

export const dialogFields = [
 { label: '任务流程', prop: 'procKeyAndDefNameList', type: 'select', checkboxName: "全选", multiple: true, fieldOption: { label: 'procDefName', value: 'key', options: [] }, placeholder: '请输入任务流程' },
 { label: '被授权人', prop: 'agent', require: true, type: 'userSelect', placeholder: '请输入被授权人姓名或工号' },
 {
  label: '授权时间', prop: 'selectedTime', require: true, type: 'datetimerange', placeholder: '选择日期时间', pickerOptions: {
   disabledDate(time) {
    return (
      new Date(new Date().toLocaleDateString()) > time.getTime()
    )
   }
  },
  defaultTime: [dayjs().add(1, 'minute').format('HH:mm:ss'), dayjs().add(1, 'minute').format('HH:mm:ss')]
 },
 // {
 //  label: '结束时间', prop: 'endTime', require: true, type: 'datetime', placeholder: '选择日期时间', pickerOptions: {
 //   disabledDate(time) {
 //    return (
 //      new Date(new Date().toLocaleDateString()) > time.getTime()
 //    )
 //   }
 //  }
 // },
]

// 表格字段
export const tableColumns = [
 { label: '授权人工号', prop: 'clientAccount', minWidth: '120' },
 { label: '授权人姓名', prop: 'client', minWidth: '120' },
 { label: '任务名称', prop: 'procDefName', minWidth: '300' },
 {
  label: '授权开始时间',
  prop: 'startTime',
  minWidth: '160',
  sortable: true
 },
 {
  label: '授权结束时间',
  prop: 'endTime',
  minWidth: '160',
  sortable: true
 },
 {
  label: '授权终止时间',
  prop: 'cancellTime',
  minWidth: '160',
  sortable: true
 },
 { label: '被授权人工号', prop: 'userId', minWidth: '120' },
 { label: '被授权人姓名', prop: 'agent', minWidth: '120' }
]
